
  import echarts from 'echarts';
  import {Component, Vue} from "vue-property-decorator";
  import dataBox from "@/views/dashboard/components/dataBox.vue";
  import dataReport from "@/views/dashboard/components/dataReport.vue";
  import dataLinechart from "@/views/dashboard/components/dataLinechart.vue";
  import {getOu} from "@/utils/cookies";

  @Component({
    name:'StoreDashboard',
    components:{
      dataBox,
      dataReport,
      dataLinechart
    }})
  export default class StoreDashboard extends Vue {

    get simpleParameter():any{
      return {
        onlyMe:false
      }
    }

    get splitToPlatformParameter():any {
      return {

      }
    }

    // API参数
    buildYearlyReportApiParameters(year:number, month:number):any{
      const parameters = {
        orgId: this.$store.getters['user/ouId'],
        Month:month,
        Year:year,
        onlyMe:true
      };
      return parameters;
    }

    buildYearlySaleReportChartOption(res:any):any{
      return this.buildYearlyLineChartOption(res,'元');
    }

    buildYearlyNewVipCountChartOption(res:any):any{
      return this.buildYearlyLineChartOption(res,'个');
    }
    buildYearlyRenewVipCountChartOption(res:any):any{
      return this.buildYearlyLineChartOption(res,'个');
    }

    buildYearlyLineChartOption(res:any,unit:string):any{
      const legendData = res.items.map((item:any)=>item.orgName);
      let seriesList:any = [];
      res.items.map((item:any,index:Number)=>{
          let seriesItem:any = {
          name: '',
          type: 'line',
          stack: '总量',
          data: []
        }
        seriesItem.name = item.orgName
        item.detail.values.map((valueItem:any,valueIndex:Number)=>{
          seriesItem.data.push(valueItem.value)
        })
        seriesList.push(seriesItem)
      });
      const option:any = {
        grid:{
          left:'60px',
          right:'10px',
          top:'10px',
          bottom:'30px'
        },
        legend: {
          data: legendData
        },
        tooltip: {
          trigger: 'axis',
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: ['1月', '2月', '3月', '4月', '5月', '6月', '7月','8月','9月','10月','11月','12月']
        },
        yAxis: {
          type: 'value'
        },
        series: seriesList
      };
      return option;
    }


    buildTestChartOption(res:any):any{
      const data = []
      for(let i = 0;i<7;i++){
        data.push(parseInt((Math.random()*1000).toFixed()));
      }
      const option:any = {
        grid:{
          left:'30px',
          right:'0px',
          top:'10px',
          bottom:'30px'
        },
        xAxis: {
          type: 'category',
          data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
        },
        yAxis: {
          type: 'value'
        },
        series: [{
          data: data,
          type: 'line'
        }]
      };
      return option;
    }

  }
